import { render, staticRenderFns } from "./Dispatches.vue?vue&type=template&id=1efa3b7f&scoped=true&"
import script from "./Dispatches.vue?vue&type=script&lang=js&"
export * from "./Dispatches.vue?vue&type=script&lang=js&"
import style0 from "./Dispatches.vue?vue&type=style&index=0&id=1efa3b7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa3b7f",
  null
  
)

export default component.exports